import { rem } from 'polished'
import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { useLocation } from 'react-router'
import styled from 'styled-components'

import CheckboxField from './CheckboxField'

import SolidInfoCircleIcon from 'components/Luxkit/Icons/solid/SolidInfoCircleIcon'
import Tooltip from 'components/Luxkit/Tooltip'
import { mediaQueryUp } from 'components/utils/breakpoint'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: ${rem(0)};

  ${mediaQueryUp.tablet} {
    margin-top: ${rem(12)};

    height: ${rem(24)};
  }
`

const CheckboxContainer = styled.div`
  margin-right: ${rem(8)};
`

function AddToItinerary() {
  const { watch, setValue } = useFormContext()

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue('isInItinerary', event.target.checked)
  }

  const isInItinerary: boolean = watch('isInItinerary')

  const location = useLocation()

  useEffect(() => {
    // default value for checkbox to true if adding from itinerary page
    const { pathname } = location
    if (pathname.toLowerCase().includes('itinerary')) {
      setValue('isInItinerary', true)
    }
  }, [location, setValue])

  return (
    <Container>
      <CheckboxContainer>
        <CheckboxField
          onChange={handleCheckboxChange}
          name="isInItinerary"
          checked={isInItinerary}
          label="Add To Itinerary"
        />
      </CheckboxContainer>
      <Tooltip description="Please add check-in/out details for inclusion on the itinerary">
        <SolidInfoCircleIcon />
      </Tooltip>
    </Container>
  )
}

export default AddToItinerary
